const uploading = "UPLOADING"
const uploaded = "FILE_UPLOADED"
const inProgress = "IN_PROGRESS"
const complete = "COMPLETE"
const created = 'CREATED'
const pending = 'PENDING'
const wordsComplete = "MARKING_WORDS_COMPLETE"
const wordsInProgress = "MARKING_WORDS_IN_PROGRESS"
const wordsAiInProgress = "MARKING_WORDS_AI_IN_PROGRESS"
const redo = "REDO"
const brokenFile = "BROKEN_FILE"
const backToMarking = "BACK_TO_MARKING"
const backToCutting = "BACK_TO_CUTTING"
const cutAudio = "CUT_AUDIO"
const audioCuttingInProgress = "AUDIO_CUTTING_IN_PROGRESS"
const audioCuttingComplete = "AUDIO_CUTTING_COMPLETE"
const transcriptionInProgress = "TRANSCRIPTION_IN_PROGRESS"
const transcriptionComplete = "TRANSCRIPTION_COMPLETE"
const backToTranscription = "BACK_TO_TRANSCRIPTION"
const recheckPending = "MARKING_WORDS_RECHECK_PENDING"
const aiPending = "MARKING_WORDS_AI_COMPLETE"
const aiFailed = "MARKING_WORDS_AI_FAILED"
const missed = "MISSED"
const notForExecution = "NOT_FOR_EXECUTION"

const statuses = {
    pending,
    inProgress,
    aiFailed,
    aiPending,
    wordsAiInProgress,
    complete,
    created,
    backToCutting,
    recheckPending,
    missed,
    wordsComplete,
    wordsInProgress,
    backToMarking,
    audioCuttingInProgress,
    audioCuttingComplete,
    transcriptionInProgress,
    transcriptionComplete,
    uploaded,
    backToTranscription,
    uploading,
    brokenFile,
    cutAudio,
    redo,
    notForExecution
}

const assessmentStatusOptions = [
    { id: 1, status: "undone", name: "לא בוצע" },
    { id: 2, status: "file_uploaded", name: "בוצע" },
    { id: 3, status: "uploading", name: "בהעלאה" },
    { id: 4, status: "in_progress", name: "בעיבוד" },
    { id: 5, status: "completed", name: "הופק דוח" },
    { id: 6, status: "redo", name: "לביצוע חוזר" },
    { id: 7, status: "missed", name: "חלף המועד" }
]

const statusOptions = [
    { id: 1, status: "undone", name: "לא בוצע" },
    { id: 2, status: "done", name: " בוצע" },
    { id: 3, status: "completed", name: "הופק דוח" },
    { id: 4, status: "redo", name: "לביצוע חוזר" },
    { id: 5, status: "missed", name: "חלף המועד" },
    { id: 6, status: "not_for_execution", name: "לא לביצוע" }
]

const PENDING_STATUSES = [statuses.created, statuses.redo]

export { PENDING_STATUSES, assessmentStatusOptions, statusOptions }
// export { wordsInProgress, inProgress, complete, created, wordsComplete }
export default statuses